const AUTH_PATHS = ["/login", "/signup", "/agency/login", "/agency/signup"];

export const isAuthPath = (pathname: string) => AUTH_PATHS.includes(pathname);

// Where the app was LOADED, fixed for the life of the page. The SPA can
// navigate away from /login without a reload, so never treat this as "where
// the user is now": use isAuthPath(location.pathname) for that. Reading it as
// the current page is what let a signed-in officer with a lapsed subscription
// open /login and get forwarded into the dashboard with no paywall check.
export const isAuthPage = isAuthPath(window.location.pathname);
